// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2-hd2","loaderOuter":"PageOverlayLoader_loaderOuter__2Ev99"};